import { useLocation } from "react-router-dom";
import Footer from "./footer/Footer";

const validPaths = [
    "/",
    "/portfolio",
    "/kblab",
    "/studycrew",
    "/summer-of-bitcoin-2024",
    "/resume",
    "/real-life-resume"
];

const Layout = ({ children }) => {
    const location = useLocation();

    const isValidPage =
        validPaths.includes(location.pathname) ||
        location.pathname.startsWith("/chat/");

    return (
        <>
            {children}
            {isValidPage && <Footer />}
        </>
    );
};

export default Layout;
